import styled from 'styled-components';

const StyledPrivacy = styled.div`
  overflow-x: hidden;

  .hero {
    width: 100vw;
    height: 40vh;
    overflow: hidden;
    position: relative;
    padding: 40px;
    border-bottom: 1px solid rgba(var(--greyr), 0.3);
    display: flex;
    align-items: flex-end;

    .content {
      position: relative;
      z-index: 2;
      pointer-events: none;
      max-width: 900px;

      h1 {
        font-size: 72px;
        line-height: 1.1;
        margin-bottom: 32px;
        color: var(--black);
      }
    }
  }

  .privacy-content {
    padding: 80px 40px;
    max-width: 900px;

    h2, h3 {
      font-family: "Cormorant Garamond", serif;
      font-size: 32px;
      margin-bottom: 24px;
    }

    p, li {
      font-size: 16px;
      line-height: 1.8;
      color: var(--grey);
      margin-bottom: 24px;
    }
  }
`;

export default StyledPrivacy;
